import { Link } from 'react-router-dom'
import { Icon, Scrollbar, Typography } from 'shared/ui'
import { type IResponseGetAgentUsage } from 'entities/AICalling/api/types'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'
import styles from './styles.module.scss'

export type IAgentUsageProps = {
  data: IResponseGetAgentUsage
  action: 'disable' | 'delete'
}

export const AgentUsage = ({ data: { inboxes }, action }: IAgentUsageProps) => {
  const inboxesNoun = `inbox${inboxes.length === 1 ? '' : 'es'}`

  const title = `AI Agent can’t be ${action === 'disable' ? 'disabled' : 'deleted'}`
  const description = `This agent is assigned to ${inboxes.length} ${inboxesNoun}. To ${action} it, remove the
            agent from all inboxes below.`

  return (
    <>
      <div className={styles.header}>
        <Icon fontSize={32} icon={'failed'} color={'var(--red-60)'} />
        <div className={styles.info}>
          <Typography ariaLabel={'title'} variant={'heading-lg'}>
            {title}
          </Typography>
          <Typography
            ariaLabel={'description'}
            variant={'body-rg-regular'}
            color={'var(--content-primary-secondary)'}
            className={styles.center}
          >
            {description}
          </Typography>
        </div>
      </div>
      <Scrollbar autoHeight autoHeightMax={256}>
        <div className={styles.list}>
          {inboxes.map(({ team_id, team_name }) => (
            <Link
              key={team_id}
              to={InboxesPath.inboxCallingV1(team_id)}
              className={styles.card}
              target={'_blank'}
            >
              <Icon icon={'inboxOpen'} className={styles.icon} />
              <Typography
                ariaLabel={'title'}
                variant={'body-md-regular'}
                ellipsis
                className={styles.title}
              >
                {team_name}
              </Typography>
              <Icon icon={'chevronRight'} className={styles.icon} />
            </Link>
          ))}
        </div>
      </Scrollbar>
    </>
  )
}
